import { render } from "./CodeEditorView.vue?vue&type=template&id=535a0910&scoped=true"
import script from "./CodeEditorView.vue?vue&type=script&lang=js"
export * from "./CodeEditorView.vue?vue&type=script&lang=js"

import "./CodeEditorView.vue?vue&type=style&index=0&id=535a0910&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535a0910"]])

export default __exports__